
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { VerificaComponent } from './verifica/verifica.component';

const routes: Routes = [
  {
    path: '',
    component: VerificaComponent,
    children: [
      {
        path: '',
        loadChildren: ()=>import('./verifica/iniciov/iniciov.module').then(m => m.IniciovModule)
      },
      {
        path: 'historico',
        loadChildren: ()=>import('./verifica/historico/historico.module').then(m => m.HistoricoModule)
      },
      {
        path: 'resumen',
        loadChildren: ()=>import('./verifica/resumen/resumen.module').then(m => m.ResumenModule)
      },
      {
        path: 'reporte',
        loadChildren: ()=>import('./verifica/reporte/reporte.module').then(m => m.ReporteModule)
      },
      {
        path: 'aceptar',
        loadChildren: ()=>import('./verifica/aceptar/aceptar.module').then(m => m.AceptarModule)
      },
    ]
  },
  {  path: '**', redirectTo: 'error' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})

export class AppRoutingModule {

}